export default {
  //is_direct: true,
  type: '',
  tax_number: '',
  phone: '',
  name: '',
  counterparty: {
    type: '',
    name: '',
    tax_number: '',
    phone: '',
  },
  contract: {
    number: null,
    date: null,
    type: '',
    amount: null,
    subject_type: '',
    action_type: '',
  },
}
